import * as React from "react";
import Tabs, { TabPane } from "rc-tabs";
import { SlideTab } from "./SlideType";

type SliderTabsProps = {
  tabs: Array<SlideTab>;
};

const SliderTabs: React.FunctionComponent<SliderTabsProps> = ({
  tabs,
}): React.ReactElement => {
  const [activeTab, setActiveTab] = React.useState("0");

  const handleTabChange = (key: string): void => {
    setActiveTab(key);
  };

  return (
    <Tabs onChange={handleTabChange} activeKey={activeTab} moreIcon={">"}>
      {tabs.map((tab, index) => (
        <TabPane
          tab={<span className="style-as-h3">{tab.title}</span>}
          key={String(index)}
        >
          <div
            dangerouslySetInnerHTML={{ __html: tab.content }}
            className="sliderWithTabs__tabContent"
          />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default SliderTabs;
